import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import IconButton from '@cotyorg/ccx-molecules/IconButton';
import SearchForm from '../SearchForm';
import SearchResults from '../SearchResults';

export const getOnInputUpdateHandler = ({
  fetchSearchResults,
  searchURL,
  locale,
}) => ({
  target = {
    value: '',
  },
} = {}) => {
  const { value } = target;
  fetchSearchResults({
    value,
    searchURL,
    locale,
  });
};

// istanbul ignore next
const Search = ({
  appElement,
  isShown,
  term,
  toggleSearchVisibility,
  placeholderText,
  contentLabel,
  clearSearchIconSrc,
  closeIconSrc,
  searchIconSrc,
  fetchSearchResults,
  clearSearch,
  loadSearchHistory,
  searchURL,
  searchPath,
  searchFieldName,
  searchButtonText,
  searchButtonHidden,
  locale,
  presentationLocale,
  isServedFromLegacySite,
}) => {
  loadSearchHistory();

  // N.B. This should be set to App root HTML element
  Modal.setAppElement(appElement);

  return (
    <Modal
      isOpen={isShown}
      onRequestClose={toggleSearchVisibility}
      shouldCloseOnOverlayClick
      className="search__modal"
      overlayClassName="search__modal-overlay"
      contentLabel={contentLabel}
    >
      <div className="search">
        <div className="grid-container">
          <div className="search__first-row-controls">
            <IconButton
              onClick={toggleSearchVisibility}
              iconSrc={closeIconSrc}
              size="small"
              extraClass="search__close-button"
            />
          </div>
        </div>
        <div className="grid-container">
          <SearchForm
            onInputUpdate={getOnInputUpdateHandler({
              fetchSearchResults,
              searchURL,
              locale,
            })}
            term={term}
            clearSearchAndInput={clearSearch}
            clearSearchIconSrc={clearSearchIconSrc}
            searchIconSrc={searchIconSrc}
            placeholder={placeholderText}
            locale={locale}
            presentationLocale={presentationLocale}
            searchPath={searchPath}
            searchFieldName={searchFieldName}
            searchButtonText={searchButtonText}
            searchButtonHidden={searchButtonHidden}
          />
          <SearchResults
            searchURL={searchURL}
            locale={locale}
            presentationLocale={presentationLocale}
            isServedFromLegacySite={isServedFromLegacySite}
          />
        </div>
      </div>
    </Modal>
  );
};

Search.propTypes = {
  fetchSearchResults: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  isShown: PropTypes.bool,
  term: PropTypes.string,
  toggleSearchVisibility: PropTypes.func,
  appElement: PropTypes.string,
  placeholderText: PropTypes.string.isRequired,
  contentLabel: PropTypes.string.isRequired,
  clearSearchIconSrc: PropTypes.string,
  closeIconSrc: PropTypes.string,
  searchIconSrc: PropTypes.string,
  loadSearchHistory: PropTypes.func.isRequired,
  searchURL: PropTypes.string.isRequired,
  searchPath: PropTypes.string,
  searchFieldName: PropTypes.string.isRequired,
  searchButtonText: PropTypes.string,
  searchButtonHidden: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  presentationLocale: PropTypes.string.isRequired,
  isServedFromLegacySite: PropTypes.bool,
};

export default Search;
